import { defineComponent } from 'vue';
var dataAreaMapType = [
    {
        title: 'イルミネーションも楽しめるフォトスポット',
        subTitle: 'Xmas Tree Area / Star Area / 日本大通り',
        imgSrc: '/images/top/area-map/img1.jpg',
        iconSrc: '/images/top/area-map/icon1.png',
        content: [
            '会場内には巨大なホワイトクリスマスツリー、横浜公園らしい星型のフォトスポットが登場予定です。さらに会場の外を出ると一般社団法人日本大通りエリアマネジメント協議会・日本大通り商店会の協力により、横浜公園から開港資料館交差点まで約430mにわたり日本大通り全体を温かい光でライトアップします。',
            '点灯時間　16時〜23時'
        ],
        note: '※画像はイメージです。今後の関係各所との協議により変更となる可能性があります。',
        color: '#DFB600',
        class: 'item__1'
    },
    {
        title: '思いきり体も動かせる遊び場',
        subTitle: 'Kids Area',
        imgSrc: '/images/top/area-map/img2.jpg',
        iconSrc: '/images/top/area-map/icon2.png',
        content: '公園のようにお子さまが体を動かして遊べる人工芝の空間を作り出します。壁面にはクリスマスのモチーフをあしらった迷路や間違い探しなど、遊び心あふれる仕掛けも展示予定です。さらに、各週末にはKids Areaを中心に大人から子どもまで楽しめるワークショップなどのイベントも予定しています。',
        color: '#00743E'
    },
    {
        title: ['クリスマスを演出する', 'バラエティ豊かなグッズ'],
        subTitle: 'Goods Area',
        imgSrc: '/images/top/area-map/img3.jpg',
        iconSrc: '/images/top/area-map/icon3.png',
        content: "「BALLPARK Xmas OFFICIAL SHOP」をはじめとする5店舗のグッズショップが出店予定です。「ムーミン」との本イベント限定デザイン「Moominvalley's Winter Rose」シリーズのオリジナルグッズや「Happy holidays!」を意味するドイツ語「Frohes Fest!」がデザインされたBPX公式グッズの他、スノードームやキャンドルホルダー、クリスマスリースなどの雑貨も販売予定です。",
        note: ['※写真はイメージです。'],
        link: [
            {
                url: '/pdf/top/gourmet&goods.pdf',
                text: '主なグッズ紹介ページはこちら',
                newTab: true
            }
        ],
        color: '#E72426',
        class: 'item__1'
    },
    {
        title: 'クリスマスを満喫できる豊富なグルメが登場',
        subTitle: 'Hutte Town Area',
        imgSrc: '/images/top/area-map/img4.jpg',
        iconSrc: '/images/top/area-map/icon4.png',
        content: '20店舗が出店しクリスマスムードを盛り上げるバラエティ豊かなグルメを提供予定です。歴史あるドイツ・フランクフルトの「シュニッツェル」や、ハート型チュロス、器まで食べられるバケットボウルのビーフシチューなど、注目メニューが勢揃い。店舗ごとに個性あふれるクリスマスキャラが乗ったココアも登場し、会場を彩ります。',
        note: '※写真はイメージです。食器類は実際のものと異なります。',
        link: [
            {
                url: '/pdf/top/gourmet&goods.pdf',
                text: '主なグルメ紹介ページはこちら',
                newTab: true
            }
        ],
        color: '#784C24',
        class: 'item__1'
    },
    {
        title: '週替りのイベントで35日間を盛り上げる',
        subTitle: 'Stage',
        imgSrc: '/images/top/area-map/img5.jpg',
        iconSrc: '/images/top/area-map/icon5.png',
        content: '2025年11月21日(金)から12月25日(木)までの35日間、週替わりでさまざまなテーマを設定し、テーマに沿ったアーティストやパフォーマーが登場し会場を盛り上げます。',
        color: '#FF7832'
    }
];
export default defineComponent({
    setup: function () {
        return { dataAreaMapType: dataAreaMapType };
    }
});
